var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FetchContainer',{attrs:{"endpoints":_vm.endpoints},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('span',{staticClass:"tag",class:_vm.getClass(slotProps.data.response.env)},[_vm._v(" "+_vm._s(slotProps.data.response.env)+" / v"+_vm._s(slotProps.data.response.version)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }